export default __webpack_public_path__ + "d218fdcccc4dfa981cb84159160be8c1.png";